import { useMemo } from 'react';
import orderBy from 'lodash/orderBy';

export default function useSectionedAssignments({ assignments = [] }) {
  const nextAssignments = useMemo(() => {
    const filteredAssignments = assignments.filter(
      (a) => !a.answered && !a.expired
    );
    return orderBy(filteredAssignments, ['expirationDate', 'asc']);
  }, [assignments]);

  const doneAssignments = useMemo(() => {
    const filteredAssignments = assignments.filter((a) => a.answered);
    return orderBy(filteredAssignments, ['answer.finishedAt', 'desc']);
  }, [assignments]);

  const expiredAssignments = useMemo(() => {
    const filteredAssignments = assignments.filter(
      (a) => a.expired && !a.answered
    );
    return orderBy(filteredAssignments, ['expirationDate', 'desc']);
  }, [assignments]);

  const pastAssignments = useMemo(() => {
    return [...doneAssignments, ...expiredAssignments];
  }, [doneAssignments, expiredAssignments]);

  return {
    nextAssignments,
    doneAssignments,
    pastAssignments,
    expiredAssignments,
  };
}
